import { createAction, props } from '@ngrx/store';
import { Transaction } from '../../models/transaction';

export const GetTransactions = createAction(
    'Get Transactions',
    props<{
        pageNumber: number;
        pageSize: number;
        searchTerm: string;
        sort: {
            [key: string]: any;
        };
        filter?: {
            [key: string]: any;
        };
        fromDate?: string;
        toDate?: string;
    }>()
);

export const GetTransactionsSuccess = createAction(
    'Get Transactions Success',
    props<{ list: Array<Transaction>; total: number }>()
);

export const GetTransactionsFailure = createAction('Get Transactions Failure', props<Error>());
